import { ActionContext } from "vuex";
import iso3166 from "iso-3166-1-alpha-2";
import { VNode } from "vue";
import TYPES from "./types";
import { RootState } from "./index";
import request from "~~/utils/request";
import { form as api } from "~~/const/apis";
// import TIMEZONES from '~~/const/timezone'
import { openedRegistCountrySet } from "~~/const/formItemConfig";
import { translateTzOption } from "~~/utils/timezone";
import { generateAdvIndustry, getForbiddenIds } from "~~/utils/generate";
import { IAdvIndustryRes, IAdvIndustry, IAdvIndustryKey, ReferralCodeInfo } from "~/types/form";
import { filterCountryList } from "~/const/formItemConfig";
interface State {
  countryList: any;
  currencyList: any[];
  timezoneList: any[];
  agencyList: [];
  advIndustryList: IAdvIndustry[];
  advIndustryRetryTimes: number;
  formData: any;
  formContentId: string;
  registerFormId: string;
  promotionSource: string;
  registeredEmail: string;
  errorEmail: string;
  submittingRegister: boolean;
  submittingLeaveinfo: boolean;
  customIsNeedPhoneNumber: boolean; // 自定义线索表单的是否需要phone，会根据它进行条款 term
  userFilledData: Record<string, any>;
  forbiddenAdvIndustryIds: IAdvIndustryKey[];
  itemDialog: Record<string, any>;
  showCheckIcon: boolean;
  referralCodeInfo: ReferralCodeInfo // 推荐码信息
}

export const state = () => ({
  countryList: {},
  currencyList: [],
  timezoneList: [],
  agencyList: [
    { value: false, labelI18n: "form_agency_no" },
    { value: true, labelI18n: "form_agency_yes" }
  ],
  advIndustryList: [],
  advIndustryRetryTimes: 0,
  formData: {
    selectCountry: {
      country: ""
    },
    register: {
      confirm: false
    },
    agencyLead: {
      competitor_platform_used: []
    },
    leaveInfo: {
      competitor_platform_used: []
    },
    registerInfo: {},
    leadFormInfo: {
      competitor_platform_used: [],
      marketing_objective: []
    }
  },
  formContentId: '',
  registerFormId: undefined,
  promotionSource: "",
  registeredEmail: "",
  errorEmail: "",
  submittingRegister: false,
  submittingLeaveinfo: false,
  customIsNeedPhoneNumber: true,
  userFilledData: {},
  forbiddenAdvIndustryIds: [],
  itemDialog: {
    dialogVisible: false,
    dialogText: "",
  },
  showCheckIcon: false,
  referralCodeInfo: {}
});

export const mutations = {
  [TYPES.SET_PROMOTION_SOURCE](state: State, route: any) {
    const platform = route?.query?.platform ?? ''
    const channel = route?.query?.channel ?? ''
    state.promotionSource =
      platform && channel ? `${platform}_${channel}` : `${platform}${channel}`;
  },
  [TYPES.SET_COUNTRY_LIST](state: State, list = {}) {
    state.countryList = list;
  },
  [TYPES.SET_CURRENCY_LIST](state: State, list = []) {
    state.currencyList = list;
  },
  [TYPES.SET_ADV_INDUSTRY_LIST](state: State, list = []) {
    state.advIndustryList = list;
  },
  [TYPES.SET_ADV_INDUSTRY_RETRY_TIMES](state: State, times: number) {
    state.advIndustryRetryTimes = times;
  },
  [TYPES.SET_TIMEZONE_LIST](state: State, data: { list: object[]; vm: VNode }) {
    const { list, vm } = data;
    state.timezoneList = list.map((item: any) => {
      item.label = translateTzOption(item, vm);
      return item;
    });
  },
  [TYPES.SET_FORM_DATA](
    state: State,
    data: { formName: string; key: string; value: any }
  ) {
    const { formName, key, value } = data;

    const { formData }: any = state;
    state.formData = {
      ...formData,
      [formName]: {
        ...formData[formName],
        [key]: typeof value === "string" ? value.trim() : value
      }
    };
  },
  [TYPES.SET_REGISTER_ID](state: State, id: string) {
    state.registerFormId = id;
  },
  [TYPES.SET_REGISTERED_EMAIL](state: State, val: string) {
    state.registeredEmail = val;
  },
  [TYPES.SET_ERROR_EMAIL](state: State, val: string) {
    state.errorEmail = val;
  },
  [TYPES.SET_REGISTER_SUBMITTING_STATE](state: State, val: boolean) {
    state.submittingRegister = val;
  },
  [TYPES.SET_LEAVEINFO_SUBMITING_STATE](state: State, val: boolean) {
    state.submittingLeaveinfo = val;
  },
  [TYPES.SET_CUSTOM_IS_NEED_PHONE_NUMBER](state: State, val: boolean) {
    state.customIsNeedPhoneNumber = val;
  },
  [TYPES.SET_USER_FILLED_DATA](state: State, val: Record<string, any>) {
    const filterVal: Record<string, any> = {};
    Object.keys(val).map(key => val[key] && (filterVal[key] = val[key]));
    state.userFilledData = { ...state.userFilledData, ...filterVal };
  },
  [TYPES.SET_FORBIDDEN_ADV_INDUSTRY_IDS](state: State, val: IAdvIndustryKey[]) {
    state.forbiddenAdvIndustryIds = val;
  },
  [TYPES.SET_FORM_CONTENT_ID](state: State, val: string) {
    state.formContentId = val;
  },
  [TYPES.SET_ITEM_DIALOG](state: State, val: Record<string, any>) {
    state.itemDialog = val;
  },
  [TYPES.SET_SHOW_CHECK_ICON](state: State, val: boolean) {
    state.showCheckIcon = val;
  },
  [TYPES.SET_REFERRAL_CODE_INFO](state: State, val: ReferralCodeInfo) {
    state.referralCodeInfo = val;
  }
};

export const getters = {
  locationCountryList: (state: State) => {
    const { countryList } = state;
    const list = [];

    for (const key in countryList) {
      if (!filterCountryList.includes(key)) {
        list.push({ value: key, label: countryList[key] });
      }
    }
    return list;
  },
  openedRegisterCountryList: (state: State) => {
    const { countryList } = state;
    const list = [];

    for (const key in countryList) {
      if (openedRegistCountrySet.has(key)) {
        list.push({ value: key, label: countryList[key] });
      }
    }
    return list;
  }
};

export const actions = {
  fetchCountryList({ commit }: ActionContext<State, RootState>) {
    const regions = iso3166.getData();
    commit(TYPES.SET_COUNTRY_LIST, regions);
  },
  fetchArtical(
    { commit }: ActionContext<State, RootState>,
    { params = {}, config = {} }
  ) {
    return request.get(api.article, params, config);
  },
  fetchTimezoneList({ commit }: ActionContext<State, RootState>, vm: VNode) {
    return request.get(api.all_timezone_list).then((res: any = {}) => {
      const { data = {} } = res;
      commit(TYPES.SET_TIMEZONE_LIST, { list: data.timezone_list || [], vm });
    });
    // TIMEZONES
    // commit(TYPES.SET_TIMEZONE_LIST, { list: TIMEZONES, vm })
  },
  fetchAdvIndustryList({
    commit,
    dispatch,
    state
  }: ActionContext<State, RootState>) {
    return request
      .get(api.adv_industry_list)
      .then(
        (res: {
          msg: string;
          data: { items: IAdvIndustryRes[] };
          code: 0 | -1 | 40002;
        }) => {
          const { data, code } = res;
          if (code === 0) {
            const advIndustryList: IAdvIndustry[] = generateAdvIndustry(
              data.items || []
            );
            commit(TYPES.SET_ADV_INDUSTRY_LIST, advIndustryList);
            const forbiddenRoot = advIndustryList.find(
              item => item.id === "forbidden"
            );
            if (forbiddenRoot) {
              commit(
                TYPES.SET_FORBIDDEN_ADV_INDUSTRY_IDS,
                getForbiddenIds(forbiddenRoot.children || [])
              );
            }
          } else if (state.advIndustryRetryTimes < 1) {
            // 请求失败重试一次
            commit(
              TYPES.SET_ADV_INDUSTRY_RETRY_TIMES,
              state.advIndustryRetryTimes + 1
            );
            setTimeout(() => dispatch("fetchAdvIndustryList"), 500);
          }
        }
      );
  },
  submitRegister({ commit }: ActionContext<State, RootState>, all: any) {
    return request.post(api.register, all.data, all.config);
  },
  submitPromotion({ commit }: ActionContext<State, RootState>, all: any) {
    return request.post(api.self_promotion, all.data, all.config);
  },
  checkCountryHasQuota(
    { commit }: ActionContext<State, RootState>,
    countryCode: string
  ) {
    return request.get(api.quota, {
      country: countryCode
    });
  },

  getLeadForms({ commit }: ActionContext<State, RootState>) {
    return request.get(api.lead_forms);
  },
  async getReferralCodeInfo({ commit }: ActionContext<State, RootState>, code: string) {
    try {
      const { data = {} } = await request.get(api.check_referral_code, {
        referral_code: code
      })

      commit(TYPES.SET_REFERRAL_CODE_INFO, data);

      return data
    } catch (error) {
      console.error(error);
    }
  },
};
